import './AssignmentPageModals.scss';

import React from 'react';
import update from 'immutability-helper';
import moment from 'moment';

import AssignmentEditAdvancedForm from './AssignmentEditAdvancedForm';
import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';

import { MODALS } from 'utils/constants';

export default class AssignmentEditAdvancedModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        openModal: React.PropTypes.func.isRequired,
        setAssignment: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        assignment: React.PropTypes.object.isRequired
    };

    componentWillReceiveProps(nextProps) {
        if(this.props.assignment.id !== nextProps.assignment.id) {
            this.mandatory = this.props.assignment.mandatory;
            this.sendReminders = this.props.assignment.sendReminders;
            this.recurrance = this.props.assignment.recurrance;
            this.recurUntil = this.props.assignment.recurUntil;
        }
    }

    _handleChange(event) {
        if(this.oldAssignment == null) {
            this.oldAssignment = JSON.parse(JSON.stringify(this.props.assignment));
        }
        let name = event.target.getAttribute('name');
        let value = event.target.value;

        if(event.target.getAttribute('type') === 'checkbox') {
            value = event.target.checked;
        }

        let newAssignmentObj = update(this.props.assignment, {});
        newAssignmentObj[name] = value;

        console.log(name, value);

        if(['mandatory', 'sendReminders', 'recurrance', 'recurUntil'].indexOf(name) !== -1) {
            this[name] = value;
        }

        if(name === 'performanceSupport') {
            if(value === true) {
                this.mandatory = this.props.assignment.mandatory;
                this.sendReminders = this.props.assignment.sendReminders;
                this.recurrance = this.props.assignment.recurrance;
                this.recurUntil = this.props.assignment.recurUntil;

                newAssignmentObj.mandatory = false;
                newAssignmentObj.sendReminders = false;
                newAssignmentObj.recurrance = 'none';
                newAssignmentObj.recurUntil = 'none';
            } else {
                newAssignmentObj.mandatory = this.mandatory;
                newAssignmentObj.sendReminders = this.sendReminders;
                newAssignmentObj.recurrance = this.recurrance;
                newAssignmentObj.recurUntil = this.recurUntil;
            }
        }

        console.log(newAssignmentObj)

        this.props.setAssignment(newAssignmentObj);
    }

    _handleDateChange(date, type) {
        //handle date change vs blur
        if(moment.isMoment(date)) {
            let newAssignmentObj = update(this.props.assignment, {});

            newAssignmentObj[type] = parseInt(date.format('x'), 10);

            this.props.setAssignment(newAssignmentObj);
        } else if(date === 'none') {
            let newAssignmentObj = update(this.props.assignment, {});

            newAssignmentObj[type] = date;

            this.props.setAssignment(newAssignmentObj);

        }
    }

    _handleRecurranceChange(value, name) {
        let newAssignmentObj = update(this.props.assignment, {});
        newAssignmentObj[name] = value;

        this.props.setAssignment(newAssignmentObj);
    }

    _openEditModal(isValid, reset) {
        if(isValid === true) {
            if(reset === true && this.oldAssignment != null) {
                this.props.setAssignment(this.oldAssignment);
            }
            delete this.oldAssignment;
            this.props.openModal(MODALS.ASSIGNMENT_EDIT);
        }
    }



    render() {
        let { assignment, closeModal, openModal, show } = this.props;

        return (
            <Modal show={show}
                   className="assignment-edit"
                   handleClose={closeModal.bind(this)}
                   width="wide">
                <ModalHeader>
                    Advanced Assignment Settings
                </ModalHeader>
                <div className="assignment-edit__form-wrapper">
                    <AssignmentEditAdvancedForm assignment={assignment}
                                                cancelAdvancedChanges={this._openEditModal.bind(this, true, true)}
                                                closeModal={closeModal.bind(this)}
                                                handleChange={this._handleChange.bind(this)}
                                                handleDateChange={this._handleDateChange.bind(this)}
                                                handleRecurranceChange={this._handleRecurranceChange.bind(this)}
                                                onValid={this._openEditModal.bind(this, true)}
                                                onInvalid={this._openEditModal.bind(this, false)}
                                                openModal={openModal.bind(this)} />
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentEditAdvancedModal.js